function Type() {
  return (
    <div>
      <li className="bullet-item">
        The class of the variant: SNP, deletion, insertion, indel, somatic SNV, substitution, sequence
        alteration, and tandem repeat{' '}
      </li>
    </div>
  );
}

export default Type;
